import { render, staticRenderFns } from "./cityDetail.vue?vue&type=template&id=27feda44&scoped=true"
import script from "./cityDetail.vue?vue&type=script&lang=js"
export * from "./cityDetail.vue?vue&type=script&lang=js"
import style0 from "./cityDetail.vue?vue&type=style&index=0&id=27feda44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27feda44",
  null
  
)

export default component.exports